import React, { Fragment } from 'react';
import styles from './CadReportBody.module.scss';
import {
  CadAddressValueType,
  CadArrestValueType,
  CadCitationValueType,
  CadFIValueType,
  CadIncidentValueType,
  CadOffenseValueType,
  CadPersonValueType,
  CadPremiseValueType,
  CadPropertyValueType,
  CADRMSReportValueType,
  CadSubjectValueType,
  CadValueType
} from '../../../../Models/CadReportValue';
import { CadInformation } from './CadInformation/CadInformation';
import { CadIncidentInformation } from './CadIncidentInformation/CadIncidentInformation';
import { Divider } from '../../../Divider/Divider';
import { CadInfractionsInformation } from './CadInfractionsInformation/CadInfractionsInformation';
import { CadFIsInformation } from './CadFIsInformation/CadFIsInformation';
import { CadPropertiesInformation } from './CadPropertiesInformation/CadPropertiesInformation';
import { CadSubjectsInformation } from './CadSubjectsInformation/CadSubjectsInformation';

export interface CadReportBodyProps {
  report: CADRMSReportValueType;
}

export const CadReportBody = ({
  report
}: CadReportBodyProps): React.ReactElement<CadReportBodyProps> => {
  return (
    <div className={styles.cadReportBody}>
      <h2 className={styles.title}>{`CAD/RMS Report`}</h2>
      {report.cad && (
        <CadInformation
          cad={report.cad as CadValueType}
          addresses={report.addresses as CadAddressValueType[]}
          premises={report.premises as CadPremiseValueType[]}
          personnel={report.personnel as CadPersonValueType[]}
        />
      )}

      {report.subjects && report.subjects.length > 0 && (
        <Fragment>
          <Divider />
          <CadSubjectsInformation
            subjects={report.subjects as CadSubjectValueType[]}
          />
        </Fragment>
      )}

      {report.incidents && report.incidents.length > 0 && (
        <Fragment>
          <Divider />
          <CadIncidentInformation
            incidents={report.incidents as CadIncidentValueType[]}
            addresses={report.addresses as CadAddressValueType[]}
            premises={report.premises as CadPremiseValueType[]}
            offenses={report.offenses as CadOffenseValueType[]}
            personnel={report.personnel as CadPersonValueType[]}
          />
        </Fragment>
      )}

      {report.arrests && report.arrests.length > 0 && (
        <Fragment>
          <Divider />
          <CadInfractionsInformation
            title="Arrest Information"
            infractions={report.arrests as CadArrestValueType[]}
            premises={report.premises as CadPremiseValueType[]}
            addresses={report.addresses as CadAddressValueType[]}
            personnel={report.personnel as CadPersonValueType[]}
            subjects={report.subjects as CadSubjectValueType[]}
            offenses={report.offenses as CadOffenseValueType[]}
          />
        </Fragment>
      )}

      {report.citations && report.citations.length > 0 && (
        <Fragment>
          <Divider />
          <CadInfractionsInformation
            title="Citation Information"
            infractions={report.citations as CadCitationValueType[]}
            premises={report.premises as CadPremiseValueType[]}
            addresses={report.addresses as CadAddressValueType[]}
            personnel={report.personnel as CadPersonValueType[]}
            subjects={report.subjects as CadSubjectValueType[]}
            offenses={report.offenses as CadOffenseValueType[]}
          />
        </Fragment>
      )}

      {report.fis && report.fis.length > 0 && (
        <Fragment>
          <Divider />
          <CadFIsInformation
            fis={report.fis as CadFIValueType[]}
            premises={report.premises as CadPremiseValueType[]}
            addresses={report.addresses as CadAddressValueType[]}
            personnel={report.personnel as CadPersonValueType[]}
            subjects={report.subjects as CadSubjectValueType[]}
          />
        </Fragment>
      )}

      {report.properties && report.properties.length > 0 && (
        <Fragment>
          <Divider />
          <CadPropertiesInformation
            properties={report.properties as CadPropertyValueType[]}
          />
        </Fragment>
      )}
    </div>
  );
};
